// The backend only exposes a single free-text "domains" field, but the
// design shows it as a chip list ("Additional domains"). Until the backend
// grows a real array field, we fake the chip UI by splitting/joining on
// commas, keeping the wire format unchanged.

export function domainsStringToChips(domainsString) {
  if (!domainsString) return [];
  return domainsString
    .split(",")
    .map((domain) => domain.trim())
    .filter(Boolean);
}

export function chipsToDomainsString(chips) {
  return chips.filter(Boolean).join(", ");
}
